<template>
    <div class="billing-center-box">
        <van-nav-bar title="添加管理员" />
        <van-form
            class="store-admin-content"
            ref="form"
            validate-first
            :show-error-message="false"
            :show-error="true"
            @failed="onFailed"
            @submit="onSubmit"
        >
            <van-field
                v-model="managerPhone"
                required
                name="managerPhone"
                label="管理员手机号"
                placeholder="请输入手机号(必填)"
                :rules="[
                    { required: true, message: '请输入手机号' },
                    { pattern: /^1[3456789]\d{9}$/, message: '请输入正确的联系电话' }
                ]"
            />
            <van-field name="mallBranchStoreID" label="所属门店" required :rules="[{ required: true, message: '请选择分店' }]">
                <template #input>
                    <van-radio-group v-model="mallBranchStoreID">
                        <van-radio
                            checked-color="#ff6633"
                            :name="item.mallBranchStoreID"
                            v-for="(item, index) in branchstoreList"
                            :key="index"
                        >
                            {{ item.simpleName }}
                        </van-radio>
                    </van-radio-group>
                </template>
            </van-field>
        </van-form>
        <div class="hhk-btn-box">
            <van-button type="default" color="#FF6633" block @click="addManager">添加管理员</van-button>
        </div>
    </div>
</template>

<script>
import { Toast } from 'vant';
import { reqAddBusiness, reqBranchstore } from '../api/business';

export default {
    data() {
        return {
            phone: '',
            managerPhone: '',
            branchstoreList: [],
            mallBranchStoreID: ''
        };
    },
    mounted() {
        this.phone = this.$globalData.phone1;
        this.getBranchstore();
    },
    methods: {
        // 获取分店信息
        getBranchstore() {
            reqBranchstore({ phone: this.phone, audit: 2 }).then(res => {
                console.log('分店列表：', res.data);
                this.branchstoreList = res.data.rows || [];
            });
        },
        addManager() {
            this.$refs.form.submit();
        },
        onFailed(errorInfo) {
            Toast(errorInfo.errors[0].message);
        },
        onSubmit({ managerPhone, mallBranchStoreID }) {
            reqAddBusiness({ phone: managerPhone, mallBranchStoreID: mallBranchStoreID, chargePhone: this.phone }).then(res => {
                console.log(res);
                this.$router.push('/storeAdmin');
            });
        }
    }
};
</script>

<style scoped lang="scss">
@mixin field-style {
    .van-field__control {
        height: 35px;
        background-color: #f5f5f5;
        padding: 0 10px;
        border-top-left-radius: 3px;
        border-bottom-left-radius: 3px;
    }
    .van-field__right-icon {
        height: 35px;
        line-height: 35px;
        background-color: #f5f5f5;
        border-top-right-radius: 3px;
        border-bottom-right-radius: 3px;
        color: #000000;
    }
}
.billing-center-box {
    height: 100vh;
    background-color: #f5f5f5;
    display: flex;
    flex-direction: column;

    .store-admin-content {
        flex: 1;
        border-top: 1px solid #eeeeee;
        overflow: auto;

        ::v-deep .van-cell {
            display: block;

            .van-cell__title {
                width: 100%;
                padding-left: 10px;
            }
            .van-cell__value .van-field__body {
                padding: 5px 0;

                .van-radio-group .van-radio {
                    margin-bottom: 10px;
                }
            }
        }

        ::v-deep .input-special-style .van-cell__value .van-field__body {
            @include field-style;
        }
    }

    .hhk-btn-box {
        padding: 10px 10px;
        background-color: #ffffff;
        border-top: 1px solid #eeeeee;

        .van-button {
            font-size: 16px;
        }
    }
}
</style>
